export default __webpack_public_path__ + "static/media/PatrickHand-Regular.d2f5b3a4.ttf";